import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c4a2428"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-node-col" }
const _hoisted_2 = {
  key: 0,
  class: "success-message"
}
const _hoisted_3 = { class: "greenText" }
const _hoisted_4 = {
  key: 1,
  class: "flex-container-row card-gap contact-support-layout"
}
const _hoisted_5 = { class: "form-fields-scroll" }
const _hoisted_6 = { class: "submit-footer" }
const _hoisted_7 = { class: "sidebar-title-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_link_button = _resolveComponent("link-button")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_phone_field = _resolveComponent("phone-field")!
  const _component_input_dropdown = _resolveComponent("input-dropdown")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loader_guard, { "has-loaded": _ctx.hasLoaded }, {
      default: _withCtx(() => [
        (_ctx.submitSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, [
                _createVNode(_component_my_icon, {
                  icon: "check",
                  color: "green"
                }),
                _createTextVNode("  " + _toDisplayString(_ctx.localize('contactSupportSuccess')), 1)
              ]),
              _createVNode(_component_link_button, {
                caption: _ctx.localize('contactSupportSubmitAnother'),
                onClick: _ctx.onSubmitAnother
              }, null, 8, ["caption", "onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_card, { class: "contact-support-form-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card_header, { class: "k-hstack section" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.localize('contactSupport')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card_body, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.localize('contactSupportDescription')), 1),
                        _createVNode(_component_input_field, {
                          id: "name",
                          "model-value": _ctx.fullName,
                          label: _ctx.localize('name'),
                          placeholder: _ctx.localize('name'),
                          disabled: true,
                          class: "form-field"
                        }, null, 8, ["model-value", "label", "placeholder"]),
                        _createVNode(_component_input_field, {
                          id: "email",
                          "model-value": _ctx.email,
                          label: _ctx.localize('email'),
                          placeholder: _ctx.localize('email'),
                          disabled: true,
                          class: "form-field"
                        }, null, 8, ["model-value", "label", "placeholder"]),
                        _createVNode(_component_phone_field, {
                          id: "phoneNumber",
                          modelValue: _ctx.formStore.phoneNumber,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formStore.phoneNumber) = $event)),
                          class: "form-field"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_input_dropdown, {
                          id: "category",
                          modelValue: _ctx.formStore.category,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formStore.category) = $event)),
                          "data-items": _ctx.categoryItems,
                          "value-field": "value",
                          "text-field": "text",
                          label: _ctx.localize('category'),
                          required: true,
                          class: "form-field"
                        }, null, 8, ["modelValue", "data-items", "label"]),
                        _withDirectives(_createVNode(_component_input_field, {
                          id: "equipmentSerialNo",
                          modelValue: _ctx.formStore.equipmentSerialNo,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formStore.equipmentSerialNo) = $event)),
                          label: _ctx.localize('equipmentSN'),
                          placeholder: _ctx.localize('enterEquipmentSerialNo'),
                          required: _ctx.isEquipmentCategory,
                          class: "form-field"
                        }, null, 8, ["modelValue", "label", "placeholder", "required"]), [
                          [_vShow, _ctx.isEquipmentCategory]
                        ]),
                        _createVNode(_component_input_field, {
                          id: "subject",
                          modelValue: _ctx.formStore.subject,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formStore.subject) = $event)),
                          label: _ctx.localize('subject'),
                          placeholder: _ctx.localize('enterSubject'),
                          required: true,
                          class: "form-field"
                        }, null, 8, ["modelValue", "label", "placeholder"]),
                        _createVNode(_component_input_field, {
                          id: "message",
                          modelValue: _ctx.formStore.message,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formStore.message) = $event)),
                          placeholder: _ctx.localize('enterMessage'),
                          required: true,
                          height: 200,
                          validator: _ctx.validateMessage,
                          class: "form-field message-field"
                        }, null, 8, ["modelValue", "placeholder", "validator"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_link_button, {
                          caption: _ctx.localize('submit'),
                          disabled: _ctx.isSubmitting,
                          onClick: _ctx.onSubmit
                        }, null, 8, ["caption", "disabled", "onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_card, { class: "contact-support-sidebar" }, {
                default: _withCtx(() => [
                  _createVNode(_component_card_header, { class: "k-hstack section" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_title, null, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, [
                            _createVNode(_component_my_icon, { icon: "email" }),
                            _createTextVNode(_toDisplayString(_ctx.localize('contactSupportInfoTitle')), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_card_body, null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_ctx.localize('contactSupportInfoText')), 1),
                      _createVNode(_component_link_button, {
                        caption: _ctx.supportEmail,
                        href: `mailto:${_ctx.supportEmail}`
                      }, null, 8, ["caption", "href"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    }, 8, ["has-loaded"])
  ]))
}